import { AccessControl } from 'src/app/shared/authentication/access-control';
import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';

/** The open incidents, newest first, with links to each one and to the Incidents page. */
export const OPEN_INCIDENTS_WIDGET: DashboardWidgetDefinition = {
  type: 'open-incidents',
  title: 'Dashboard.OpenIncidents.Title',
  description: 'The newest open incidents with their category, severity, facilities and status.',
  icon: 'assignment',
  loadComponent: () => import('./open-incidents-widget.component').then((m) => m.OpenIncidentsWidgetComponent),
  frame: 'edge',
  size: { default: { w: 8, h: 4 }, min: { w: 4, h: 3 } },
  permissions: [AccessControl.IncidentPermissionIncidentEventView],
};
